import { render, staticRenderFns } from "./custom-settings.vue?vue&type=template&id=f175be80"
import script from "./custom-settings.vue?vue&type=script&lang=js"
export * from "./custom-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports